import React from 'react';
import { PurchaseOrders } from 'components/app/erp/purchase-order';

// Route-level page entry for ERP Procurement → Purchase Orders (list).
const PurchaseOrderPage = () => <PurchaseOrders />;

export default PurchaseOrderPage;
